import React from 'react';

const Hero = () => {
  return (
    <div className="relative bg-deep-blue">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-deep-blue to-black opacity-70"></div>
        {/* This would be replaced with an actual image in production */}
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center"></div>
      </div>
      <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl font-montserrat">
          PRECISION AUTOMOTIVE SOLUTIONS
        </h1>
        <p className="mt-6 text-xl text-white max-w-3xl font-roboto">
          Quality Automotive Monitors and Interior Electronics Assembly, Inspection, and Distribution
        </p>
        <div className="mt-10">
          <a
            href="/services"
            className="inline-block bg-light-blue hover:bg-blue-700 text-white font-montserrat font-semibold uppercase tracking-wider py-3 px-8 border border-transparent rounded-md shadow-md transition duration-300"
          >
            EXPLORE OUR SERVICES
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
